import { render, staticRenderFns } from "./printer.vue?vue&type=template&id=87dc3bdc&scoped=true"
import script from "./printer.vue?vue&type=script&lang=js"
export * from "./printer.vue?vue&type=script&lang=js"
import style0 from "./printer.vue?vue&type=style&index=0&id=87dc3bdc&prod&lang=scss&scoped=true"
import style1 from "./printer.vue?vue&type=style&index=1&id=87dc3bdc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "87dc3bdc",
  null
  
)

export default component.exports